import { defineMessages } from "react-intl";

const messages = defineMessages({
  date: {
    id: "riskManagement.components.summary.date",
    defaultMessage: "Date",
  },
  slice: {
    id: "riskManagement.components.summary.slice",
    defaultMessage: "Slice",
  },
  req: {
    id: "riskManagement.components.summary.req",
    defaultMessage: "Requirement",
  },
  reqChg: {
    id: "riskManagement.components.summary.req.change",
    defaultMessage: "Change from SOD",
  },
  rangeHigh: {
    id: "riskManagement.components.summary.highRange",
    defaultMessage: "Day's High",
  },
  rangeLow: {
    id: "riskManagement.components.summary.lowRange",
    defaultMessage: "Day's Low",
  },
  errorHeader: {
    id: "riskManagement.components.summary.error.header",
    defaultMessage: "Error: Summary is currently unavailable",
  },
  errorBody: {
    id: "riskManagement.components.summary.error.body",
    defaultMessage:
      "Refresh the page and if issue persists contact the Apex Business Automation Team",
  },
});

export default messages;
